import { connect } from 'react-redux';
import Header from './Header';
import { getUserManual, videoViewerByStockOpen } from '../../store/actions/userManual';
import { modalMessageOpen, modalQRLinkOpen, modalSurveyOpen } from '../../store/actions/modal';
import {
  userLogoutRequest,
  userGetInfo,
  userCorporate,
  userSetTheme,
  userMessageInfoVisibleClose,
  userMessageInfoVisibleOpen,
  userConsentNeed,
  userConsentSave
} from '../../store/actions/user';
import { messageList } from '../../store/actions/settings';
import { getUrlWebSSOLogout } from '../../store/actions/auth';
import { surveyList } from '../../store/actions/survey';

const mapStateToProps = ({
  userReducer,
  authReducer,
  stockReducer,
  settingsReducer,
  surveyReducer,
  modalReducer
}) => ({
  userReducer,
  authReducer,
  stockReducer,
  settingsReducer,
  surveyReducer,
  modalReducer
});
const mapDispatchToProps = {
  getUrlWebSSOLogout,
  getUserManual,
  messageList,
  modalMessageOpen,
  modalQRLinkOpen,
  modalSurveyOpen,
  surveyList,
  userCorporate,
  userGetInfo,
  userLogoutRequest,
  userMessageInfoVisibleClose,
  userMessageInfoVisibleOpen,
  userSetTheme,
  videoViewerByStockOpen,
  userConsentNeed,
  userConsentSave
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Header);
